import { render, staticRenderFns } from "./SepararCuenta.vue?vue&type=template&id=3a046923&scoped=true"
import script from "./SepararCuenta.vue?vue&type=script&lang=js"
export * from "./SepararCuenta.vue?vue&type=script&lang=js"
import style0 from "./SepararCuenta.vue?vue&type=style&index=0&id=3a046923&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a046923",
  null
  
)

export default component.exports